"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ToggleButtonGroup_1 = __importDefault(require("@mui/lab/ToggleButtonGroup"));
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const ToggleButtonGroup = (props) => react_1.default.createElement(ToggleButtonGroup_1.default, { ...props });
const TimePickerPeriodToggle = ({ value, onChange, onFocus, onBlur, }) => (react_1.default.createElement(index_1.Box, null,
    react_1.default.createElement(ToggleButtonGroup, { value: value, size: "small", exclusive: true, onChange: (_, p) => p && onChange(p), onFocus: onFocus, onBlur: onBlur }, ['AM', 'PM'].map((p) => (react_1.default.createElement(index_1.ToggleButton, { key: p, value: p }, p))))));
exports.default = TimePickerPeriodToggle;
